export const whatHappenedData = {
  buttons: [
    {
      label: 'It was left with a neighbour who claims not to have it',
      id: 'withNeighbour',
    },
    {
      label: 'It was left somewhere and is now missing',
      id: 'leftSomewhere',
    },
    {
      label: 'Something else',
      id: 'somethingElse',
    },
  ],
  title: 'What happened to your item?',
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/3b77a800c8c0-tooliconwarning.jpg',
  },
}
